import { appstr } from "./appstr";
import { sanitizeBlockedValue } from "./FormatFieldValue";
import type { QObjDBObject } from "../CoreApp/QXDoc";

export const FormatPositionLabel = (position: QObjDBObject) => {
  const emptyValue = `<${appstr("None")}>`;

  const parentClass = position.GetParentClass();
  const titleFieldDef = parentClass?.GetTitleFieldDef();
  const idFieldDef = parentClass?.GetRecordIDFieldDef();

  const titleValue = sanitizeBlockedValue(position.GetFieldValue(titleFieldDef!)) || emptyValue;
  const idValue = sanitizeBlockedValue(position.GetFieldValue(idFieldDef!)) || emptyValue;

  return `${titleValue}: ${idValue}`;
};
